export interface UIStateInterface {
    isDepositAccountsOpen: boolean;
    isCommissionsOpen: boolean;
    isPasswordOpen: boolean;
    isSessionTimeOpen: boolean;
    isModalMovOpen: boolean;
    isLoginCheckLoading: boolean;
    isModalHelpOpen: boolean;
    isLoadingActive: boolean;
    isShowBalance: boolean;
    isTwoFactorOpen: boolean;
}
export class UIState implements UIStateInterface {
    isDepositAccountsOpen: boolean = false;
    isCommissionsOpen: boolean = false;
    isPasswordOpen: boolean = false;
    isSessionTimeOpen: boolean = false;
    isModalMovOpen: boolean = false;
    isLoginCheckLoading: boolean = true;
    isModalHelpOpen: boolean = false;
    isLoadingActive: boolean = false;
    isShowBalance: boolean = true;
    isTwoFactorOpen: boolean = false;

    constructor(state: UIStateInterface) {
        this.isDepositAccountsOpen = state.isDepositAccountsOpen;
        this.isCommissionsOpen = state.isCommissionsOpen;
        this.isPasswordOpen = state.isPasswordOpen;
        this.isSessionTimeOpen = state.isSessionTimeOpen;
        this.isModalMovOpen = state.isModalMovOpen;
        this.isLoginCheckLoading = state.isLoginCheckLoading;
        this.isModalHelpOpen = state.isModalHelpOpen;
        this.isLoadingActive = state.isLoadingActive;
        this.isShowBalance = state.isShowBalance;
        this.isTwoFactorOpen = state.isTwoFactorOpen;
    }
}